import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'semantic-ui-react';
import { TagColor } from 'components';

import styles from './TagColorDropdown.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const TagColorDropdown = ({ currentTag, onCheckColorEdit }) => {
  const { isDropdown } = currentTag.toJS();
  const wrapWidth = 250;
  const wrapHeight = window.innerHeight - 50;
  const dropdownWidth = 140;
  const dropdownHeight = 182;
  const horizontal = dropdownHeight + isDropdown.top > wrapHeight ? 'top' : 'bottom';
  const vertical = isDropdown.left > 119 ? 'left' : 'right';

  const offset = {
    top: horizontal === 'top' ? isDropdown.top - dropdownHeight - 3 : isDropdown.top + 12 + 3,
    left:
      (vertical === 'right' && (isDropdown.left + dropdownWidth > wrapWidth ? 116 : isDropdown.left - 3)) ||
      (vertical === 'left' && (isDropdown.left + 12 > dropdownWidth ? isDropdown.left + 12 - dropdownWidth + 3 : 3))
  };

  //upward={}
  return (
    <div className={cx('tagColor-dropdown-wrapper')} style={offset}>
      {isDropdown.isView && (
        <Dropdown className={cx('tagColor-dropdown')} open>
          <Dropdown.Menu>
            <TagColor color={currentTag.getIn(['isEditData', 'color'])} onCheckColor={onCheckColorEdit} />
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

TagColorDropdown.propTypes = {};
TagColorDropdown.defaultProps = {};

export default TagColorDropdown;



// WEBPACK FOOTER //
// ./src/script/components/tag/TagColorDropdown.js